import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AdminMenu from "../components/AdminMenu";
import "bootstrap-icons/font/bootstrap-icons.css";

interface AuthentifiedPageProps {
  leftButtons?: any;
  rightButton?: any;
  children?: React.ReactNode;
}

const AuthentifiedPage: React.FC<AuthentifiedPageProps> = ({ leftButtons, rightButton, children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  if (!user) return null;

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="data-page d-flex flex-column min-vh-100">

      {/* Header */}
      <div style={{ marginLeft: "20vw", marginRight: "3vw" }}>
        <Header user={user} logout={handleLogout} />
      </div>

      {/* Contenu principal avec menu */}
      <div className="d-flex flex-grow-1 overflow-hidden">

        {/* Menu Admin */}
        <div className="flex-grow-0">
          <AdminMenu currentUser={user} />
        </div>

        {/* Contenu scrollable */}
        <div
          className="flex-grow-1 overflow-auto"
          style={{
            marginLeft: "20vw",
            marginRight: "3vw",
            paddingBottom: "80px", // espace pour le footer
          }}
        >
          {children}
        </div>
      </div>

      {/* Footer fixe */}
      {((leftButtons?.length ?? 0) > 0 || rightButton != null) && (
        <div
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 10,
            marginLeft: user.role === "Admin" ? "20vw" : "0",
            marginRight: user.role === "Admin" ? "3vw" : "0",
          }}
        >
          <Footer leftButtons={leftButtons} rightButton={rightButton} />
        </div>
      )}
    </div>
  );
};

export default AuthentifiedPage;
